import SubNews from 'app/components/topNewsModule/subNews/SubNews';
import React, { useCallback, useMemo } from 'react';
import SwipeableViewsStepper from 'app/components/swipeableViews/SwipeableViewsStepper';
import { Container, SubNewsWrapper } from 'app/components/topNewsModule/subNews/subNewsStyles';
import splitArrayIntoChunks from 'app/components/swipeableViews/splitArrayIntoChunks';
import { DistrictMainPageModuleType, useDistrictMainPageTracking } from 'app/components/district/news/DistrictMainPageTracking';
import isInvalidViewData from 'app/components/swipeableViews/isInvalidViewData';
export default function SwipeableNewsList(_ref) {
  let {
    newsList,
    newsPerView,
    updateTrackingData
  } = _ref;
  const {
    trackClickedItemPage
  } = useDistrictMainPageTracking();
  const viewData = useMemo(() => {
    return splitArrayIntoChunks(newsList, newsPerView);
  }, [newsList, newsPerView]);
  const renderView = useCallback(_ref2 => {
    let {
      index
    } = _ref2;
    const handleOnClick = pageIndex => {
      trackClickedItemPage(DistrictMainPageModuleType.TOPNEWS, pageIndex);
    };
    if (isInvalidViewData(viewData, index)) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Container, {
      onClick: () => handleOnClick(index),
      key: "news-".concat(newsPerView, "-").concat(index)
    }, viewData[index].map((newsData, elementIndex) => {
      if (!newsData) {
        return /*#__PURE__*/React.createElement(SubNewsWrapper, {
          key: "news-filler-".concat(newsPerView, "-").concat(elementIndex)
        });
      }
      return /*#__PURE__*/React.createElement(SubNews, {
        key: "sub-news-".concat(newsPerView, "-").concat(newsData.news.id),
        data: newsData
      });
    }));
  }, [trackClickedItemPage, newsPerView, viewData]);
  return /*#__PURE__*/React.createElement(SwipeableViewsStepper, {
    callback: updateTrackingData,
    stepCount: viewData.length,
    viewRender: renderView,
    "data-sentry-element": "SwipeableViewsStepper",
    "data-sentry-component": "SwipeableNewsList",
    "data-sentry-source-file": "SwipeableNewsList.tsx"
  });
}